$(function() {
  try {
    if ( $('body').is('#bureau.business') ) {
      $('#cont a').each(function() {
        let href = $(this).attr('href')

        if ( new RegExp('^http').test(href) ) {
          $(this)
            .addClass('is-exlink')
            .attr('target', '_blank')
        }
      })
    }
  } catch (error) {
    return null
  }
})



// WEBPACK FOOTER //
// ./_src/js/cont/bureau-business.js